var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main-form" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row center-xs" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("p", [
                _vm._v(
                  "Se ha enviado el código de verificación al correo: " +
                    _vm._s(_vm.email_enmascarado)
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card__content" }, [
                _c("div", { staticClass: "row center-xs" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-4" },
                    [
                      _c("input-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "######",
                            expression: "'######'"
                          }
                        ],
                        ref: "codigo_verificacion",
                        attrs: {
                          type: "tel",
                          id: "codigo_verificacion",
                          placeholder: "Ingrese código de verificación...",
                          autofocus: ""
                        },
                        model: {
                          value: _vm.form.codigo_verificacion,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "codigo_verificacion", $$v)
                          },
                          expression: "form.codigo_verificacion"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-buttons" }, [
          _c("div", { staticClass: "row center-xs" }, [
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn-primary btn--bigger",
                  attrs: {
                    disabled: _vm.bloquear_reenvio_codigo,
                    tooltip: _vm.bloquear_reenvio_codigo
                      ? "Debe esperar 10 min. para poder re-enviar de nuevo."
                      : null,
                    type: "button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.reenviarCodigoVerificacion()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-refresh" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Re-enviar código de verificación")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn-success btn--bigger",
                  attrs: {
                    tooltip: _vm.bloquear_verificar_codigo
                      ? "Debe esperar 10 min. para poder verificar de nuevo."
                      : null,
                    disabled:
                      !_vm.tieneCodigoVerificacion ||
                      (_vm.tieneCodigoVerificacion &&
                        _vm.bloquear_verificar_codigo),
                    type: "button"
                  },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.aceptar()
                    },
                    click: function($event) {
                      return _vm.aceptar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-check" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Verificar")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { class: _vm.claseNotification() }, [
                _c("i", { staticClass: "fa fa-clock-o" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(" Vigencia de código: "),
                  _c("strong", [_vm._v(_vm._s(this.tiempo_vigencia))])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Autenticación de dos factores")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ba17e8b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba17e8b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/codigo-verificacion/CodigoVerificacion.vue
// module id = 627
// module chunks = 0